
import pic1 from '../../../images/blog/grid/PSX.jpg';
import pic2 from '../../../images/blog/grid/absorbante.jpg';
import pic3 from '../../../images/blog/grid/oeufs.jpeg';
import pic4 from '../../../images/blog/grid/box.jpg';


export const datas = [
    {
        title: " • Barquettes pré-emballées",
        pic: ` ${pic1}`,
        text: "Les emballages alimentaires (Barquettes Standards) sont parfaitement adaptés à l’emballage d’aliments frais ayant une durée de conservation limitée. Ils peuvent être fermés avec du film étirable ou avec un sachet.",
    },
    {
        title: " • Barquettes auto-absorbantes",
        pic: ` ${pic2}`,
        text: "Grâce à de petits trous dans le fond, les liquides peuvent pénétrer à l’intérieur de la coque où ils sont liés à la structure du matériau.",
    },
    {
        title: " • Box Ouefs",
        pic: ` ${pic3}`,
        text: "Les plateaux de DEVPACK sont des emballages pour oeufs en Polystrène expansé (PSX). Ces plateaux sont résistans aux chocs et ils sont disponible en différentes tailles: valise de 6, 15, 24 et 30 Oeufs. ",
    },
    {
        title: " • Box Restauration Rapide",
        pic: ` ${pic4}`,
        text: "Les box de DEVPACK sont des emballages pratiques en Polystrène expansé (PSX). Les boites avec couvercle intégré existent en différentes formes et dimensions.",
    },


];
